var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isShow)?_c('div',[_c('Navbar'),_c('router-view'),_c('Footer'),(_vm.isTool)?_c('Tool'):_vm._e()],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }